module.exports = __webpack_public_path__ + "static/media/icon-star-filled.90639294.svg";